export const Config = {
    serviceUrl: 'https://al5-app06.adia.tv',
    serviceId: 'anivo360',
    documentTitle: 'ANIVO Live',
    theme: 'anivo',
};
